import { Component, Input } from '@angular/core';
import { IAfiliado, IAfiliadosDataSource, IAfiliadosTotals, IReporteMoraPresunta } from 'src/app/models/direccion-trabajo/mora-presunta.model';
import { PdfGeneratorService } from 'src/app/shared/services/pdf-generator.service';
import { AlertService } from '../../_alert/alert.service';
import { goToTop } from 'src/app/shared/utils/utils';

@Component({
    selector: 'app-mora-presunta-viewer',
    templateUrl: './mora-presunta-viewer.component.html',
    styleUrls: ['./mora-presunta-viewer.component.scss']
})
export class MoraPresuntaViewerComponent {

    @Input() content!: IReporteMoraPresunta;
    @Input() showHeader = true;

    private idTransaccion!: string;
    public rut = '';
    public today = '';

    public totals: IAfiliadosTotals[] = [];
    
    public afiliadosDataSource: IAfiliadosDataSource[] = [];
    public afiliadosDisplayedColumns: string[] = [
        'rutAfiliado',
        'nombreAfiliado',
        'tipoProducto',
        'afpOAfc',
        'periodoRegularizar',
        'fechaCarta',
        'contacto',
        'telefonoContacto',
        'correoContacto',
    ];

    isPDFLoading = false;
    PDF_REPORT_NAME = 'moraPresunta';

    constructor(
        private pdfGeneratorService: PdfGeneratorService,
        private alertService: AlertService,
    ) {}

    ngOnInit(): void {
        this.setAfiliadosDataSource();
        this.setRut();
        this.setToday();
        this.setTotals();

        this.idTransaccion = this.content.DatosBasicosSolicitud.IDTransaccion;
    }

    setAfiliadosDataSource() {
        this.afiliadosDataSource = this.content.Reporte.report.afiliados.map((afiliado: IAfiliado) => ({
            rutAfiliado: afiliado.rut,
            nombreAfiliado: afiliado.nombre,
            tipoProducto: afiliado.tipoProducto,
            afpOAfc: afiliado.afpOrAfc,
            periodoRegularizar: afiliado.periodoARegulizar,
            fechaCarta: afiliado.fechaCarta,
            contacto: afiliado.contacto.nombre,
            telefonoContacto: afiliado.contacto.telefono,
            correoContacto: afiliado.contacto.correo
        }))
    }

    setRut() {
        this.rut = this.content.DatosBasicosSolicitud.Rut + '-' + this.content.DatosBasicosSolicitud.DV
    }

    setToday() {
        this.today = `${new Date().getFullYear()}${(new Date().getMonth() + 1 < 10 ? '0' + (new Date().getMonth() + 1) :
            new Date().getMonth() + 1)}${new Date().getDate()}`;
    }

    setTotals() {
        const afiliados = this.content.Reporte.report.afiliados || []
        const map = new Map<string, number>();

        for (const { tipoProducto } of afiliados) {
            map.set(tipoProducto, (map.get(tipoProducto) ?? 0) + 1);
        }

        this.totals = Array.from(map, ([tipoProducto, count]) => ({ tipoProducto, count }));
    }

    getPDF() {
        this.isPDFLoading = true;
        this.pdfGeneratorService._getPDF(this.idTransaccion, this.PDF_REPORT_NAME).subscribe(
            response => {
                if (response.URLReporte) {
                    window.open(response.URLReporte, '_blank');
                }
                this.isPDFLoading = false;
            },
            ({error}) => {
                this.alertService.error(`Error al obtener el PDF: ${error?.message}`);
                goToTop();

                this.isPDFLoading = false;
            }
        )
    }

    generatePDF() {
        this.isPDFLoading = true;
        this.pdfGeneratorService._generatePDF(this.idTransaccion, this.PDF_REPORT_NAME, '', '', this.rut).subscribe(
            () => {
                this.getPDF();
            },
            ({error}) => {
                this.alertService.error(`Error al generar el PDF: ${error?.message}`);
                goToTop();

                this.isPDFLoading = false;
            }
        )
    }

}
